<template>
  <MainHeader header__white="header__white" />
  <Breadcrumb :title="post.title" :subtitle="post.title" />
  <section class="blog-details__area pt-120 pb-120">
      <div class="container">
         <div class="row">
            <div class="col-xxl-10 offset-xxl-1">
               <div class="blog-details__wrapper">
                  <div class="blog-details__img mb-45">
                     <img :src="post.image" :alt="post.title">
                  </div>
                  <div class="blog-details__content">
                     <h1 class="blog-details__title">{{ post.title }}</h1>
                     <div class="blog-details__text" v-html="formattedContent"></div>
                  </div>
               </div>
            </div>
         </div>
      </div>
    </section>
  <Footer footerPadding="true" />
</template>

<script>
import { ref, computed, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import { jsonService } from '@/services/jsonService'
import MainHeader from '../components/Home/Header.vue'
import Footer from '../components/Home/Footer.vue'
import Breadcrumb from '../components/common/Breadcrumb.vue'
import { useSeo, createSlug as makeSlug, truncate, SITE_URL } from '@/composables/useSeo'

export default {
  name: "BlogDetails",
  components: {
    MainHeader,
    Footer,
    Breadcrumb
  },
  setup() {
    const route = useRoute()
    const post = ref({})

    const createSlug = makeSlug

    const formattedContent = computed(() => {
      if (!post.value.content) return ''
      return post.value.content.replace(/\n/g, '<br>')
    })

    const applySeo = (p) => {
      const url = `/blog-details/${createSlug(p.title)}`
      const image = p.image ? (p.image.startsWith('http') ? p.image : SITE_URL + p.image) : undefined
      const description = truncate(p.content, 160)
      useSeo({
        title: p.title,
        description,
        image,
        url,
        type: 'article',
        jsonLd: {
          '@context': 'https://schema.org',
          '@type': 'Article',
          headline: p.title,
          description,
          image: image ? [image] : undefined,
          datePublished: p.createdAt,
          dateModified: p.createdAt,
          author: { '@type': 'Organization', name: 'GelişimP Türkiye' },
          publisher: {
            '@type': 'Organization',
            name: 'GelişimP Türkiye',
            logo: { '@type': 'ImageObject', url: SITE_URL + '/images/logo.png' }
          },
          mainEntityOfPage: { '@type': 'WebPage', '@id': SITE_URL + url }
        }
      })
    }

    const loadPost = async () => {
      const posts = await jsonService.getBlogPosts()
      const foundPost = posts.find(p => createSlug(p.title) === route.params.slug)
      if (foundPost) {
        post.value = foundPost
        applySeo(foundPost)
      }
    }

    onMounted(() => {
      loadPost()
    })

    return {
      post,
      formattedContent
    }
  }
}
</script>

<style scoped>
.page__title-2 {
    font-size: 40px;
    color: #fff;
    line-height: 1.1;
    margin-bottom: 20px;
}

.blog-details__img {
    border-radius: 10px;
    overflow: hidden;
    margin-top: -100px;
    position: relative;
    z-index: 1;
}

.blog-details__img img {
    width: 100%;
    height: auto;
}

.blog-details__title {
    font-size: 32px;
    font-weight: 700;
    color: #0e1133;
    margin-bottom: 30px;
}

.blog-details__text {
    color: #666;
    font-size: 16px;
    line-height: 1.8;
}

.blog-details__text :deep(p) {
    margin-bottom: 15px;
}

.blog-details__wrapper {
    background: #fff;
    padding: 40px;
    border-radius: 10px;
    box-shadow: 0 10px 30px rgba(0,0,0,0.05);
}
</style>
